import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import logo from "../../../assets/images/logo.png";
import "./navbar.css";


class NavBar extends Component {
    state = {
        isOpenNavBar: false
    }

    openHandler = () => {
        const openState = this.state.isOpenNavBar;
        this.setState({ isOpenNavBar: !openState });
    }
    menuClickHandler = () => {
        this.setState({ isOpenNavBar: false });
    }

    render() {

        return (
            <React.Fragment>
                <header className="nav_bar">
                    <NavLink exact to="/" id='navbar-logo'><img src={logo} onClick={this.menuClickHandler} alt="logo" /></NavLink>
                    <span id="bar-icon-menu" onClick={this.openHandler}>{this.state.isOpenNavBar ? <i className="fa fa-times fa-2x" aria-hidden="true" /> : <i className="fa fa-bars fa-2x" aria-hidden="true" />}</span>
                    <nav>
                        <ul className={this.state.isOpenNavBar ? "nav_links menu_on" : "nav_links"}>
                            <li onClick={this.menuClickHandler}><NavLink to="/news">ニュース</NavLink></li>
                            <li onClick={this.menuClickHandler} className="has-sub">
                                <NavLink to="/service">サービス</NavLink>
                                <div className="sub-menu">
                                    <ul className="sub-items">
                                        <li><a href="/service#system-container">システム開発</a></li>
                                        <li><a href="/service#package-container">パッケージ開発・導入</a></li>
                                        <li><a href="/service#tech-container">技術支援</a></li>
                                        <li><a href="/service#infra-container">インフラ構築</a></li>
                                    </ul>
                                </div>
                            </li>
                            <li onClick={this.menuClickHandler} className="has-sub">
                                <NavLink to="/company">会社情報</NavLink>
                                <div className="sub-menu">
                                    <ul className="sub-items">
                                        <li><a href="/company#greetings">代表挨拶</a></li>
                                        <li><a href="/company#company">会社概要</a></li>
                                        <li><a href="/company#history">沿革</a></li>
                                    </ul>
                                </div>
                            </li>
                            <li onClick={this.menuClickHandler} className="has-sub">
                                <NavLink to="/people">チームについて</NavLink>
                                <div className="sub-menu">
                                    <ul className="sub-items">
                                        <li><a href="/people">求める人材</a></li>
                                        <li><a href="/people#voices">先輩社員の声</a></li>
                                    </ul>
                                </div>
                            </li>
                            <li onClick={this.menuClickHandler} className="has-sub">
                                <NavLink to="/recruit">採用情報</NavLink>
                                <div className="sub-menu">
                                    <ul className="sub-items">
                                        <li><a href="/recruit/headquarter">新卒採用【本社】</a></li>
                                        <li><a href="/recruit/tokyo">新卒採用【東京】</a></li>
                                        <li><a href="/recruit/mid-level-engineer">中途採用／システムエンジニア</a></li>
                                        <li><a href="/recruit/mid-level-programmer">中途採用／プログラマー</a></li>
                                    </ul>
                                </div>
                            </li>
                            <li onClick={this.menuClickHandler} id="contact_nav_button" className="has-sub">
                                <NavLink to="/contact" className="bg-blue">CONTACT US</NavLink>
                            </li>
                        </ul>
                    </nav>
                </header>
            </React.Fragment>
        )
    }
}


export default NavBar;